export const actions: any = [
  {
    title: 'Upload',
    action: 'upload',
    hidden: false,
    icon: 'upload-blue-icon',
  },
];
